<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import BrandLogo from '@/assets/img/svg/brand-logo.svg?component'

const router = useRouter()
const { t } = useI18n({ useScope: 'global' })

withDefaults(
  defineProps<{
    title?: string
    description?: string
    errorCode?: string
    showActions?: boolean
  }>(),
  {
    showActions: true,
  },
)

const goHome = () => router.push('/')
</script>

<template>
  <div class="flex flex-col space-y-16 items-center justify-center">
    <BrandLogo />
    <OState
      type="error"
      class="w-96"
      :state="{
        title: title || t('ostate.you_are_lost'),
        description: description || t('ostate.looking_for_page'),
        errorCode: errorCode || '404',
      }"
    >
      <template #actions v-if="showActions">
        <div class="flex justify-center">
          <OButton
            variant="primary"
            size="L"
            class="!w-auto"
            @click="goHome"
            :label="t('go_to_home')"
          />
        </div>
      </template>
    </OState>
  </div>
</template>
